import React, { createContext, useState } from "react"
import md5 from "md5"

export const ProtectRoutesContext = createContext()

export const ProtectRoutesProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  const login = (password) => {
    const correctHashedPassword = "83a1345fca4507bf793c4192f2189e75" // MD5 of 'slots@123'
    const enteredHashedPassword = md5(password)

    if (enteredHashedPassword === correctHashedPassword) {
      setIsAuthenticated(true)
      return true
    } else {
      return false
    }
  }

  return (
    <ProtectRoutesContext.Provider value={{ isAuthenticated, login }}>
      {children}
    </ProtectRoutesContext.Provider>
  )
}
